<div class="navbar navbar-fixed navbar-toggleable-sm navbar-deloitte-light">
    <div class="navbar-container justify-content-between">
        <div class="navbar-brand" href="#">
            <span class="navbar-mobile-title">
               About
           </span>
        </div>
    </div>
</div>

<div class="container mt-5">
    <div class="row mt-5">
        <div class="col col-md-8 col-md-push-2">
            <div class="user-content" [innerHTML]="aboutText"></div>
        </div>
    </div>
</div>
